const IPI = {
  "situacao_tributaria": null, //OBRIGATORIO SEMPRE
  "codigo_enquadramento": null, //OBRIGATORIO SEMPRE
  "aliquota": 0.00, //OBRIGATORIO SEMPRE
  "percentual_devolvido": 0.00,
  "ipi_devolvido": 0.00,
  "codigo_selo": null,
  "qtd_selo": 0,
  "bc_ipi": null,
}

const PIS = {
  "situacao_tributaria": null, //OBRIGATORIO SEMPRE
  "aliquota": 0.00, //OBRIGATORIO SEMPRE
  "majoracao": 0.00,
  "bc_pis": 0.00,
}

const COFINS = {
  "situacao_tributaria": null, //OBRIGATORIO SEMPRE
  "aliquota": 0.00, //OBRIGATORIO SEMPRE
  "majoracao": 0.00,
  "bc_cofins": 0.00,
}

const ISSQN = {
  "codigo_cfop": null, //OBRIGATORIO SEMPRE
  "exigibilidade": null, //OBRIGATORIO SEMPRE
  "item_servico": null, //OBRIGATORIO SEMPRE
  "incentivo_fiscal": false, //OBRIGATORIO SEMPRE
  "aliquota": 0.00, //OBRIGATORIO SEMPRE
  "deducao": 0.00,
  "retencoes": 0.00,
  "desconto_incondicionado": 0.00,
  "desconto_condicionado": 0.00,
  "iss_retido": 0.00,
  "municipio": null,
  "codigo_servico": null,
  "processo": null,
}

const IBS_CBS = {
  "situacao_tributaria": null, //OBRIGATORIO SEMPRE
  "classificacao_tributaria": null, //OBRIGATORIO SEMPRE
  "situacao_tributaria_regular": null,
  "classificacao_tributaria_regular": null,
  "ibs_estadual": {
    "aliquota_diferimento": 0.00, // Obrigatório quando situação tributária = 510
    "valor_devolvido": 0.00
  },
  "ibs_municipal": {
    "aliquota_diferimento": 0.00, // Obrigatório quando situação tributária = 510
    "valor_devolvido": 0.00
  },
  "cbs": {
    "aliquota_diferimento": 0.00, // Obrigatório quando situação tributária = 510
    "valor_devolvido": 0.00
  },
  "tributacao_monofasica": { //Obrigatório para situação tributária 620.
    "quantidade_bc": 0, //OBRIGATORIO SEMPRE
    "aliquota_ibs": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_cbs": 0.00, //OBRIGATORIO SEMPRE
    "quantidade_bc_retencao": 0,
    "aliquota_ibs_retencao": 0.00,
    "aliquota_cbs_retencao": 0.00,
    "quantidade_bc_retido": 0,
    "aliquota_ibs_retido": 0.00,
    "aliquota_cbs_retido": 0.00,
    "aliquota_diferimento_ibs": 0.00,
    "aliquota_diferimento_cbs": 0.00,
  },
  "credito_presumido": {
    "classificacao": null, //OBRIGATORIO SEMPRE
    "bc": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_ibs": 0.00,
    "aliquota_cbs": 0.00,
  },
  "transferencia_credito": {
    "valor_ibs": 0.00, //OBRIGATORIO SEMPRE
    "valor_cbs": 0.00, //OBRIGATORIO SEMPRE
  },
  "ajuste_competencia": { //Obrigatório para situação tributária 811.
    "competencia_apuracao": null, //OBRIGATORIO SEMPRE - AAAA-MM
    "valor_ibs": 0.00, //OBRIGATORIO SEMPRE
    "valor_cbs": 0.00, //OBRIGATORIO SEMPRE
  },
  "estorno_credito": {
    "valor_ibs": 0.00,
    "valor_cbs": 0.00,
  }
}

const ICMS_SIMPLE = {
  "aliquota": 0.00,
  "aliquota_fcp": 0.00,
  "aliquota_interestadual": 0.00,
  "codigo_cfop": null,
  "situacao_tributaria": null, //OBRIGATORIO SEMPRE
  "aliquota_importacao": 0.00,
  "industria": null,
  "majoracao": 0.00,
  "bc_icms": 0.00,
  "bc_icms_st": 0.00,
  "aliquota_diferimento": 0.00,
  "credito_presumido": {
    "codigo_beneficio_fiscal": null,
    "aliquota": 0.00,
    "valor": 0.00,
  }
}

const ICMS_NORMAL = {
  "aliquota": 0.00,
  "aliquota_fcp": 0.00,
  "aliquota_interestadual": 0.00,
  "codigo_cfop": null,
  "situacao_tributaria": null,
  "aliquota_importacao": 0.00,
  "industria": null,
  "majoracao": 0.00,
  "difal_antecipacao": false,
  "bc_icms": 0.00,
  "bc_icms_st": 0.00,
  "credito_presumido": {
    "codigo_beneficio_fiscal": null,
    "aliquota": 0.00,
    "valor": 0.00,
  },
}

export const DEFAULT_TAXES = {
  "icms": ICMS_SIMPLE,
  "ipi": IPI,
  "pis": PIS,
  "cofins": COFINS,
  "issqn": ISSQN,
  "ibs_cbs": IBS_CBS
}

export const ICMS_TAXATION = {
  "101": {
    ...ICMS_SIMPLE,
    "aliquota_credito": 0.00, //OBRIGATORIO SEMPRE
  },
  "102": {
    ...ICMS_SIMPLE,
  },
  "103": {
    ...ICMS_SIMPLE,
  },
  "201": {
    ...ICMS_SIMPLE,
    "aliquota_st": 0.00,
    "aliquota_fcp_st": 0.00,
    "aliquota_mva": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_credito": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_reducao": 0.00,
    "aliquota_reducao_st": 0.00,
  },
  "202": {
    ...ICMS_SIMPLE,
    "aliquota_st": 0.00,
    "aliquota_fcp_st": 0.00,
    "aliquota_mva": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_reducao": 0.00,
    "aliquota_reducao_st": 0.00,
  },
  "203": {
    ...ICMS_SIMPLE,
    "aliquota_st": 0.00,
    "aliquota_fcp_st": 0.00,
    "aliquota_mva": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_reducao": 0.00,
    "aliquota_reducao_st": 0.00,
  },
  "300": {
    ...ICMS_SIMPLE,
  },
  "400": {
    ...ICMS_SIMPLE,
  },
  "500": {
    ...ICMS_SIMPLE,
    "bc_st_retido": 0.00,
    "aliquota_st_retido": 0.00,
    "valor_st_retido": 0.00,
    "valor_icms_substituto": 0.00,
    "valor_fcp_retido": 0.00,
    "aliquota_fcp_retido": 0.00,
    "aliquota_bc_efetivo": 0.00,
    "aliquota_icms_efetivo": 0.00,
  },
  "900": {
    ...ICMS_SIMPLE,
    "aliquota_reducao": null,
    "aliquota_reducao_st": null,
    "aliquota_st": null,
    "aliquota_fcp_st": null,
    "aliquota_mva": null,
    "aliquota_credito": null,
  },
  "00": {
    ...ICMS_NORMAL,
    "pauta_fiscal": 0 //OBRIGATORIO SEMPRE
  },
  "02": {
    ...ICMS_NORMAL,
    "quantidade_bc": 0 //OBRIGATORIO SEMPRE
  },
  "10": {
    ...ICMS_NORMAL,
    "aliquota_st": 0.00,
    "aliquota_fcp_st": 0.00,
    "aliquota_mva": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_reducao_st": 0.00,
    "motivo_desoneracao_st": null,
  },
  "15": {
    ...ICMS_NORMAL,
    "quantidade_retencao": 0, //OBRIGATORIO SEMPRE
    "aliquota_retencao": 0.00, //OBRIGATORIO SEMPRE
    "percentual_reducao": 0.00,
    "motivo_reducao": null,
    "quantidade_bc": 0,
  },
  "20": {
    ...ICMS_NORMAL,
    "aliquota_reducao": 0.00, //OBRIGATORIO SEMPRE
    "motivo_desoneracao": null,
    "deducao_desoneracao": null,
  },
  "30": {
    ...ICMS_NORMAL,
    "aliquota_st": 0.00,
    "aliquota_fcp_st": 0.00,
    "aliquota_mva": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_reducao_st": 0.00,
    "motivo_desoneracao_st": null,
    "motivo_desoneracao": null,
    "deducao_desoneracao": null,
  },
  "40": {
    ...ICMS_NORMAL,
    "motivo_desoneracao": null,
    "deducao_desoneracao": null,
  },
  "41": {
    ...ICMS_NORMAL,
    "motivo_desoneracao": null,
    "deducao_desoneracao": null,
  },
  "50": {
    ...ICMS_NORMAL,
    "motivo_desoneracao": null,
    "deducao_desoneracao": null,
  },
  "51": {
    ...ICMS_NORMAL,
    "aliquota_diferimento": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_diferimento_fcp": 0.00,
    "motivo_desoneracao": 0.00,
  },
  "53": {
    ...ICMS_NORMAL,
    "aliquota_diferimento": 0.00,
    "quantidade_bc": 0,
  },
  "60": {
    ...ICMS_NORMAL,
    "bc_st_retido": 0.00,
    "aliquota_st_retido": 0.00,
    "valor_st_retido": 0.00,
    "bc_st_dest": 0.00,
    "valor_st_dest": 0.00,
    "valor_fcp_retido": 0.00,
    "aliquota_fcp_retido": 0.00,
    "aliquota_bc_efetivo": 0.00,
    "aliquota_icms_efetivo": 0.00,
  },
  "61": {
    ...ICMS_NORMAL,
    "quantidade_bc": 0,
  },
  "70": {
    ...ICMS_NORMAL,
    "aliquota_st": 0.00,
    "aliquota_fcp_st": 0.00,
    "aliquota_mva": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_reducao": 0.00, //OBRIGATORIO SEMPRE
    "aliquota_reducao_st": 0.00,
    "motivo_desoneracao": null,
    "motivo_desoneracao_st": null,
    "deducao_desoneracao": null,
  },
}

// TOGGLE INPUTS


const TOGGLE_SIMPLE_ICMS = {
  "aliquota": true,
  "aliquota_fcp": true,
  "aliquota_interestadual": true,
  "codigo_cfop": true,
  "situacao_tributaria": true, //OBRIGATORIO SEMPRE
  "aliquota_importacao": true,
  "industria": true,
  "majoracao": true,
  "bc_icms": true,
  "bc_icms_st": true,
  "aliquota_diferimento": true,
  "credito_presumido": true
}

const TOGGLE_SIMPLE_NORMAL = {
  "aliquota": true,
  "aliquota_fcp": true,
  "aliquota_interestadual": true,
  "codigo_cfop": true,
  "situacao_tributaria": true,
  "aliquota_importacao": true,
  "industria": true,
  "majoracao": true,
  "difal_antecipacao": true,
  "bc_icms": true,
  "bc_icms_st": true,
  "credito_presumido": {
    "codigo_beneficio_fiscal": true,
    "aliquota": true,
    "valor": true,
  },
}

export const TOGGLE_INPUTS_ICMS = {
  "101": {
    ...TOGGLE_SIMPLE_ICMS,
    "aliquota_credito": true,
  },
  "102": {
    ...TOGGLE_SIMPLE_ICMS,
  },
  "103": {
    ...TOGGLE_SIMPLE_ICMS,
  },
  "201": {
    ...TOGGLE_SIMPLE_ICMS,
    "aliquota_st": true,
    "aliquota_fcp_st": true,
    "aliquota_mva": true, //OBRIGATORIO SEMPRE
    "aliquota_credito": true, //OBRIGATORIO SEMPRE
    "aliquota_reducao": true,
    "aliquota_reducao_st": true,
  },
  "202": {
    ...TOGGLE_SIMPLE_ICMS,
    "aliquota_st": true,
    "aliquota_fcp_st": true,
    "aliquota_mva": true, //OBRIGATORIO SEMPRE
    "aliquota_reducao": true,
    "aliquota_reducao_st": true,
  },
  "203": {
    ...TOGGLE_SIMPLE_ICMS,
    "aliquota_st": true,
    "aliquota_fcp_st": true,
    "aliquota_mva": true, //OBRIGATORIO SEMPRE
    "aliquota_reducao": true,
    "aliquota_reducao_st": true,
  },
  "300": {
    ...TOGGLE_SIMPLE_ICMS,
  },
  "400": {
    ...TOGGLE_SIMPLE_ICMS,
  },
  "500": {
    ...TOGGLE_SIMPLE_ICMS,
    "bc_st_retido": true,
    "aliquota_st_retido": true,
    "valor_st_retido": true,
    "valor_icms_substituto": true,
    "valor_fcp_retido": true,
    "aliquota_fcp_retido": true,
    "aliquota_bc_efetivo": true,
    "aliquota_icms_efetivo": true,
  },
  "900": {
    ...TOGGLE_SIMPLE_ICMS,
    "aliquota_reducao": true,
    "aliquota_reducao_st": true,
    "aliquota_st": true,
    "aliquota_fcp_st": true,
    "aliquota_mva": true,
    "aliquota_credito": true,
  },
  "00": {
    ...TOGGLE_SIMPLE_NORMAL,
    "pauta_fiscal": true
  },
  "02": {
    ...TOGGLE_SIMPLE_NORMAL,
    "quantidade_bc": true //OBRIGATORIO SEMPRE
  },
  "10": {
    ...TOGGLE_SIMPLE_NORMAL,
    "aliquota_st": true,
    "aliquota_fcp_st": true,
    "aliquota_mva": true, //OBRIGATORIO SEMPRE
    "aliquota_reducao_st": true,
    "motivo_desoneracao_st": true,
  },
  "15": {
    ...TOGGLE_SIMPLE_NORMAL,
    "quantidade_retencao": true, //OBRIGATORIO SEMPRE
    "aliquota_retencao": true, //OBRIGATORIO SEMPRE
    "percentual_reducao": true,
    "motivo_reducao": true,
    "quantidade_bc": true,
  },
  "20": {
    ...TOGGLE_SIMPLE_NORMAL,
    "aliquota_reducao": true, //OBRIGATORIO SEMPRE
    "motivo_desoneracao": true,
    "deducao_desoneracao": true,
  },
  "30": {
    ...TOGGLE_SIMPLE_NORMAL,
    "aliquota_st": true,
    "aliquota_fcp_st": true,
    "aliquota_mva": true, //OBRIGATORIO SEMPRE
    "aliquota_reducao_st": true,
    "motivo_desoneracao_st": true,
    "motivo_desoneracao": true,
    "deducao_desoneracao": true,
  },
  "40": {
    ...TOGGLE_SIMPLE_NORMAL,
    "motivo_desoneracao": true,
    "deducao_desoneracao": true,
  },
  "41": {
    ...TOGGLE_SIMPLE_NORMAL,
    "motivo_desoneracao": true,
    "deducao_desoneracao": true,
  },
  "50": {
    ...TOGGLE_SIMPLE_NORMAL,
    "motivo_desoneracao": true,
    "deducao_desoneracao": true,
  },
  "51": {
    ...TOGGLE_SIMPLE_NORMAL,
    "aliquota_diferimento": true, //OBRIGATORIO SEMPRE
    "aliquota_diferimento_fcp": true,
    "motivo_desoneracao": true,
  },
  "53": {
    ...TOGGLE_SIMPLE_NORMAL,
    "aliquota_diferimento": true,
    "quantidade_bc": true,
  },
  "60": {
    ...TOGGLE_SIMPLE_NORMAL,
    "bc_st_retido": true,
    "aliquota_st_retido": true,
    "valor_st_retido": true,
    "bc_st_dest": true,
    "valor_st_dest": true,
    "valor_fcp_retido": true,
    "aliquota_fcp_retido": true,
    "aliquota_bc_efetivo": true,
    "aliquota_icms_efetivo": true,
  },
  "61": {
    ...TOGGLE_SIMPLE_NORMAL,
    "quantidade_bc": true,
  },
  "70": {
    ...TOGGLE_SIMPLE_NORMAL,
    "aliquota_st": true,
    "aliquota_fcp_st": true,
    "aliquota_mva": true, //OBRIGATORIO SEMPRE
    "aliquota_reducao": true, //OBRIGATORIO SEMPRE
    "aliquota_reducao_st": true,
    "motivo_desoneracao": true,
    "motivo_desoneracao_st": true,
    "deducao_desoneracao": true,
  },
  "90": {
    ...TOGGLE_SIMPLE_NORMAL,
    "aliquota_st": true,
    "aliquota_fcp_st": true,
    "aliquota_mva": true, //OBRIGATORIO SEMPRE
    "aliquota_reducao": true, //OBRIGATORIO SEMPRE
    "aliquota_reducao_st": true,
    "motivo_desoneracao": true,
    "motivo_desoneracao_st": true,
    "deducao_desoneracao": true,
  },
}